import PropTypes from 'prop-types';

// mui
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

// hooks
import { useTheme } from '@mui/material';
import useResponsive from 'hooks/useResponsive';
import useVirgoContent from 'hooks/useVirgoContent';

// components
import Chips from './Chips';
import Circles from './Circles';

const DiscoverSectionDefaultPropSx = {};

const DiscoverSection = ({ sx = DiscoverSectionDefaultPropSx }) => {
  const theme = useTheme();
  const isMobile = useResponsive('down', 'md');
  const { circles, chips } = useVirgoContent();

  const stackGap = isMobile ? '20px' : '30px';

  return circles?.data?.length > 0 || chips?.data?.length > 0 ? (
    <Container
      data-testid="fyp-discover-section-container"
      maxWidth="xl"
      sx={{
        [theme.breakpoints.down('sm')]: {
          pl: '10px',
          pr: 0,
        },
        ...sx,
      }}
    >
      <Stack direction="column" width="100%" gap={stackGap} flexWrap="nowrap">
        <Stack
          ml="5px"
          flexWrap="nowrap"
          direction="column"
          alignItems="flex-start"
          justifyContent="flex-start"
          sx={{
            [theme.breakpoints.down('sm')]: {
              pr: '10px',
            },
          }}
        >
          <Typography data-testid="fyp-discover-section-title" variant="h6" display="block" fontWeight="700">
            Discover unique collections curated by CREOATE
          </Typography>
          <Typography
            gutterBottom
            color="black"
            display="block"
            sx={{
              [theme.breakpoints.down('sm')]: {
                mt: theme.spacing(0.5),
              },
            }}
            data-testid="fyp-discover-section-subtitle"
          >
            Let&apos;s check high search terms together to find what is hot-trending now.
          </Typography>
        </Stack>
        <Stack
          width="100%"
          gap={stackGap}
          flexWrap="nowrap"
          direction="column"
          alignItems="center"
          justifyContent="flex-start"
          sx={{
            [theme.breakpoints.up('lg')]: {
              px: '80px',
            },
          }}
          data-testid="fyp-discover-section-content-container"
        >
          <Circles />
          <Chips />
        </Stack>
      </Stack>
    </Container>
  ) : null;
};

DiscoverSection.propTypes = {
  sx: PropTypes.shape({}),
};

export default DiscoverSection;
